import { DEFAULT_AUDIO_TITLE } from '@listening/utils/ts-utils';

export function isGeneratedChapterTitle(title?: string | null) {
  const normalized = title?.trim();
  if (!normalized) return false;
  return /^chapter\s+\d+$/i.test(normalized);
}

export function getDisplayAudioTitle(title?: string | null) {
  const normalized = title?.trim();
  if (!normalized) {
    return DEFAULT_AUDIO_TITLE;
  }
  return normalized;
}

export function getDisplayAudioSubtitle(
  subtitle?: string | null,
  fallbackSubtitle?: string | null,
) {
  const normalized = subtitle?.trim();
  if (!normalized || isGeneratedChapterTitle(normalized)) {
    const fallback = fallbackSubtitle?.trim();
    if (!fallback || isGeneratedChapterTitle(fallback)) {
      return undefined;
    }
    return fallback;
  }
  return normalized;
}

export function getDisplayAudioListSubtitle(audioItem: {
  description?: string | null;
  progress?: { chapter_title?: string | null } | null;
}) {
  return getDisplayAudioSubtitle(
    audioItem.description,
    audioItem.progress?.chapter_title,
  );
}
